<template>
  <div>
    <DSButton
      v-if="!confirmVisible"
      class="button--empty button--warning"
      @click.native="toggleConfirmMsg()"
    >
      <slot />
    </DSButton>

    <div v-else>
      <DSButton
        class="button--empty"
        @click.native="toggleConfirmMsg()"
      >
        Cancel
      </DSButton>
      <span class="separator" role="presentational" />
      <DSButton
        class="button--empty button--warning"
        @click.native="onClick()"
      >
        Yes, <slot />
      </DSButton>
    </div>
  </div>
</template>

<script>
import DSButton from './DSButton'
export default {

  name: 'DSConfirmButton',

  components: {
    DSButton,
  },

  props: {
    onClick: {
      type: Function,
      required: true,
    },
  },

  data () {
    return {
      confirmVisible: false,
    }
  },

  methods: {
    toggleConfirmMsg() {
      this.confirmVisible = !this.confirmVisible
    },
  },
}
</script>

<style lang="scss" scoped>
.separator {
  content: '';
  display: inline-block;
  width: 1px;
  height: 3em;
  background-color: #CCC;
  margin: -1.25em 1em;
}
.button--warning {
  color: #F71F4A;
}
button {
  &:hover, &:focus {
    background-color: #efefef;
  }
}
</style>
